{
  "title": "Launchpad de Salt",
  "subtitle": "Les prédications, les chants d'adoration et les événements de votre église. Ouvrez le lien que votre église a partagé, ou téléchargez l'application Salt pour les suivre."
}
